/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Accesstokenforexternals3Inputs */

const de__field_accesstokenforexternals3 = /** @type {(inputs: _Field_Accesstokenforexternals3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Token für externe Lehrkräfte`)
};

/**

* @param {_Field_Accesstokenforexternals3Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_accesstokenforexternals3 = /** @type {((inputs?: _Field_Accesstokenforexternals3Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Accesstokenforexternals3Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_accesstokenforexternals3(inputs)
});
export { _field_accesstokenforexternals3 as "_field_accessTokenForExternals" }